import { ENDPOINTS } from 'src/constants/endpoints'

import { HANWHA_ORG_ID } from 'src/app/auth/constants/organization'
import type { IMemberInsightsListResponseDTO } from 'src/app/home/pages/member-insights/domain/contracts/member-insights'
import { http } from 'src/interfaces/http'

export interface IGetMemberInsightsParams {
  page: number
  pageSize: number
  search?: string
  category?: string
}

export const getMemberInsights = async (
  params: IGetMemberInsightsParams,
): Promise<IMemberInsightsListResponseDTO> => {
  const { data } = await http.get<IMemberInsightsListResponseDTO>(
    ENDPOINTS.hanwha.memberInsights,
    {
      params: {
        org_id: HANWHA_ORG_ID,
        page: params.page,
        page_size: params.pageSize,
        ...(params.search ? { search: params.search } : {}),
        ...(params.category ? { category: params.category } : {}),
      },
    },
  )
  return data
}
